import { useState } from 'react';

import { useAuth } from '@/context/AuthContext';
import { formatarCpf, pareceCpf } from '@/lib/cpf';

import {
  AlertaErro,
  AlertaSucesso,
  AuthShell,
  BotaoPrimario,
  CampoTexto,
  LinkAuth,
} from './AuthShell';

export default function EsqueciSenhaPage() {
  const [identificador, setIdentificador] = useState('');
  const [erro, setErro] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [carregando, setCarregando] = useState(false);

  const { esqueciSenha } = useAuth();

  const handleChange = (e) => {
    const valor = e.target.value;
    setIdentificador(pareceCpf(valor) ? formatarCpf(valor) : valor);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setCarregando(true);

    try {
      await esqueciSenha(identificador.trim());
      setEnviado(true);
    } catch {
      setErro('Não foi possível enviar agora. Tente novamente.');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <AuthShell
      titulo="Esqueci minha senha"
      subtitulo="Enviaremos um link para você criar uma nova"
      rodape={<LinkAuth to="/login">Voltar para o login</LinkAuth>}
    >
      {enviado ? (
        <AlertaSucesso>
          Se existir uma conta com esse e-mail ou CPF, o link de redefinição já
          está a caminho. Confira sua caixa de entrada e o spam.
        </AlertaSucesso>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <CampoTexto
            rotulo="E-mail ou CPF"
            name="identificador"
            autoComplete="username"
            autoFocus
            required
            placeholder="voce@email.com"
            value={identificador}
            onChange={handleChange}
          />

          <AlertaErro>{erro}</AlertaErro>

          <BotaoPrimario type="submit" carregando={carregando}>
            Enviar link
          </BotaoPrimario>
        </form>
      )}
    </AuthShell>
  );
}
